import DayPickerInput from 'react-day-picker/DayPickerInput';
import defaultProps from 'recompose/defaultProps';
import 'react-day-picker/lib/style.css';
import './overrides.css';

export default defaultProps({
  todayButton: 'Today',
})(DayPickerInput);
